import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@shadcn-in-nx/ui/card";
import { AlertTriangle, CheckCircle, BarChart3 } from "lucide-react";

export default function StatsBar({ total, unresolved, categories }) {
    const topCategories = (categories || [])
        .sort((a, b) => b.count - a.count)
        .slice(0, 3);

    return (
        <div className="grid grid-cols-3 gap-4">
            <Card>
                <CardHeader className="pb-2">
                    <CardTitle className="text-sm font-medium text-muted-foreground">Total Reports</CardTitle>
                </CardHeader>
                <CardContent>
                    <div className="text-2xl font-bold flex items-center gap-2">
                        <BarChart3 className="h-5 w-5 text-blue-500" />{total}
                    </div>
                </CardContent>
            </Card>
            <Card>
                <CardHeader className="pb-2">
                    <CardTitle className="text-sm font-medium text-muted-foreground">Unresolved</CardTitle>
                </CardHeader>
                <CardContent>
                    <div className="text-2xl font-bold flex items-center gap-2">
                        <AlertTriangle className="h-5 w-5 text-amber-500" />{unresolved}
                    </div>
                </CardContent>
            </Card>
            <Card>
                <CardHeader className="pb-2">
                    <CardTitle className="text-sm font-medium text-muted-foreground">Top Categories</CardTitle>
                </CardHeader>
                <CardContent>
                    <div className="flex gap-2 flex-wrap">
                        {topCategories.map((c) => (
                            <span key={c.category} className="text-sm bg-muted px-2 py-0.5 rounded">
                                {c.category}: {c.count}
                            </span>
                        ))}
                        {topCategories.length === 0 && <span className="text-sm text-muted-foreground">None</span>}
                    </div>
                </CardContent>
            </Card>
        </div>
    );
}
